import script from "./ViewDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewDocument.vue?vue&type=script&setup=true&lang=ts"

import "./ViewDocument.vue?vue&type=style&index=0&id=fa8027e0&lang=scss"

const __exports__ = script;

export default __exports__